module.exports = __webpack_public_path__ + "img/452.8f4b1f18.jpg";